import I18n from 'i18n-js';
import { Alert } from '@helpers';

// Shown when the two selected NC file versions have identical content, so there is nothing to diff.
export const showIdenticalVersionsAlert = () => {
  Alert({
    title: I18n.t('No Differences Found'),
    text: I18n.t('These versions are identical.'),
    actions: [{ text: I18n.t('OK'), style: 'primary' }],
  });
};
